import { GenericMqttMessage } from '../generic-mqtt-message.model';
import { GetCourseReportContent } from './get-course-report-content.model';

export class GetCourseReportMessage extends GenericMqttMessage {

    constructor(json: any = null) {
        super(null);

        if (json) {
            Object.assign(this, json);

            if (json.content) this.content = new GetCourseReportContent(json.content);
        }
    }

    content: GetCourseReportContent;

}
